export default __webpack_public_path__ + "locales/tr/Article.json?hash=ee046f9cab4116545c58427088175750";